import e from "../../_virtual/_plugin-vue_export-helper.js";
import t from "./CodeExample.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                */
//#region src/code-example/components/CodeExample.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-5374efff"]]);
//#endregion
export { n as default };

//# sourceMappingURL=CodeExample.vue.js.map